"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var redux_1 = require("redux");

var react_redux_1 = require("react-redux");
/**
 * Hook factory, which creates a `useActions` hook bound to dispatch.
 *
 * @param actions object with actions to bind to dispatch.
 *
 * @example
 * // actions.js
 * import { bindActionCreators } from 'react-redux'
 *
 * export const doSomething = e => ({
 *   type: 'sometype',
 *   payload: e.target.value,
 * })
 *
 * export const useActions = createActionsHook({ doSomething })
 *
 * // component.js
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 * import { useActions } from './actions'
 *
 * export const MyComponent = ({ id, text }) => {
 *   const action = useActions()
 *   return (
 *     <button value={id} onClick={action.doSomething}>
 *       {text}
 *     </button>
 *   )
 * }
 */


function createActionsHook(actions) {
  return function useActions(deps) {
    if (deps === void 0) {
      deps = [];
    }

    var dispatch = react_redux_1.useDispatch();
    return react_1.useMemo(function () {
      if (Array.isArray(actions)) {
        return actions.map(function (a) {
          return redux_1.bindActionCreators(a, dispatch);
        });
      }

      return redux_1.bindActionCreators(actions, dispatch);
    }, deps ? __spreadArrays([dispatch], deps) : [dispatch]);
  };
}

exports.createActionsHook = createActionsHook;
/**
 * useActions hook bound to the context's dispatch
 *
 * @param actions object with actions to bind to dispatch.
 * @param deps optional array of dependencies.
 */

function useActions(actions, deps) {
  if (deps === void 0) {
    deps = [];
  }

  return createActionsHook(actions)(deps);
}

exports.useActions = useActions;